import { render, staticRenderFns } from "./SiteConfig.vue?vue&type=template&id=c8fd31e8&scoped=true&"
import script from "./SiteConfig.vue?vue&type=script&lang=js&"
export * from "./SiteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fd31e8",
  null
  
)

export default component.exports